import { render, staticRenderFns } from "./ProjectOrderTabs.vue?vue&type=template&id=22b39058&scoped=true&"
import script from "./ProjectOrderTabs.vue?vue&type=script&lang=ts&"
export * from "./ProjectOrderTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectOrderTabs.vue?vue&type=style&index=0&id=22b39058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b39058",
  null
  
)

export default component.exports